import React, { useEffect } from "react";
import { Doughnut } from "react-chartjs-2";

const UsageDoughnutChart = ({ monthlyUsage }) => {
  // useEffect(() => {
  //   console.log("________________MU________________");
  //   console.log(monthlyUsage);
  // }, []);

  // Sort by totalUniqueVisits and slice to get top 20
  const sortedChartData = monthlyUsage
    .sort((a, b) => b[1].totalUniqueVisits - a[1].totalUniqueVisits)
    .slice(0, 20)
    .map((book) => ({
      label: book[1].title,
      value: book[1].totalUniqueVisits,
    }));

  // useEffect(() => {
  //   console.log("DATA______________________");
  //   console.log(sortedChartData);
  // }, [sortedChartData]);

  const chartOptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  // Array of 20 unique colors
  const colors = [
    "rgb(0, 0, 0)",
    "rgb(25, 25, 25)",
    "rgb(51, 51, 51)",
    "rgb(76, 76, 76)",
    "rgb(102, 102, 102)",
    "rgb(127, 127, 127)",
    "rgb(153, 153, 153)",
    "rgb(178, 178, 178)",
    "rgb(204, 204, 204)",
    "rgb(229, 229, 229)",
    "rgb(240, 240, 240)",
    "rgb(229, 229, 229)",
    "rgb(204, 204, 204)",
    "rgb(178, 178, 178)",
    "rgb(153, 153, 153)",
    "rgb(127, 127, 127)",
    "rgb(102, 102, 102)",
    "rgb(76, 76, 76)",
    "rgb(51, 51, 51)",
    "rgb(25, 25, 25)",
  ];

  const data = {
    labels: sortedChartData.map((item) => item.label),
    datasets: [
      {
        label: "Book Usage",
        data: sortedChartData.map((item) => item.value),
        backgroundColor: colors,
        hoverOffset: 4,
      },
    ],
  };

  return (
    <div style={{ height: 300, width: 300 }}>
      <Doughnut data={data} options={chartOptions} />
    </div>
  );
};

export default UsageDoughnutChart;
